<template>
  <el-col :span="24" id="departments">
    <el-row type="flex" justify="start" align="middle" id="departments-header">
      <HeaderInfoText :colspan="9" title="DEPARTMENTS" :meta="meta" :selection="selection" />
      <el-col :span="6">
        <el-row type="flex" justify="center" v-if="meta.count > 20">
          <el-pagination
            layout="prev, pager, next, jumper"
            :total="meta.count"
            :page-size="20"
            :current-page.sync="currentPage">
          </el-pagination>
        </el-row>
      </el-col>
      <el-col :span="9" class="h-padded right-aligned-col">
        <div class="selected-element">
        <el-select
          :disabled="!(selection && selection.length)"
          v-model="batchUpdateSelection"
          placeholder="With selected..."
          style="padding: 0 6px;"
          @change="confirmDeletingDepartment">
          <el-option
            v-for="option in batchUpdateOptions"
            :key="option.id"
            :label="option.text"
            :value="option.id">
          </el-option>
        </el-select>
        <el-button
          type="primary"
          icon="plus"
          @click="createNewModel"
        ></el-button>
        </div>
      </el-col>
    </el-row>
    <el-row type="flex" justify="end" align="middle">
      <el-col :span="24">
        <el-table
          v-if="meta.count && !changingPage"
          id="departments-table"
          :ref="`${endpoint}Table`"
          :data="pageData"
          border
          style="width: 100%; z-index: 0;"
          :maxHeight="tableHeight"
          @select="handleTableSelectionChange"
          @select-all="handleTableSelectionChange"
          :row-class-name="tableRowClassName">
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column prop="code" label="Code" align="center" width="120">
            <template slot-scope="scope">
              <el-row type="flex" justify="center">
                <a class="link-mock" @click="editExistingModel(scope.row.id)">
                  {{ scope.row.code }}
                </a>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="Department Name" align="left" fit>
            <template slot-scope="scope">
              <el-row type="flex">
                {{ scope.row.name }}
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="Description" align="left" fit>
            <template slot-scope="scope">
              <el-row type="flex">
                {{ scope.row.description ? scope.row.description : '' }}
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="from_account" label="From account" align="left" fit>
            <template slot-scope="scope">
              <el-row v-if="scope.row.from_account">
                <span type="flex" v-if="scope.row.from_account && scope.row.from_account.code">
              {{ scope.row.from_account.code }}
              </span> -
              <span type="flex" v-if="scope.row.from_account && scope.row.from_account.name">
              {{ scope.row.from_account.name }}
              </span>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="to_account" label="To account" align="left" fit>
            <template slot-scope="scope">
                <el-row v-if="scope.row.to_account">
                <span type="flex" v-if="scope.row.to_account && scope.row.to_account.code">
              {{ scope.row.to_account.code }}
              </span> -
              <span type="flex" v-if="scope.row.to_account && scope.row.to_account.name">
              {{ scope.row.to_account.name }}
              </span>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="all_accounts" label="All accounts" align="left" fit>
            <template slot-scope="scope">
              <el-tag :type="scope.row.all_accounts ? 'success' : 'danger'" close-transition>
                {{ scope.row.all_accounts ? 'Yes' : 'No' }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog
      :title="editMode.active ? `Edit Department` : 'Create New Department'"
      size="small"
      :visible.sync="dialogFormVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false">
      <NewEntityForm
        :modalOpen="dialogFormVisible"
        :fields="fields"
        :form.sync="form"
        :idPrefix="'a-'"
        ref="form"
        @update:form="trackFormChange"
      />
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="saving || !!updating" @click="closeFormModal">Cancel</el-button>
        <el-button :loading="saving || !!updating" type="primary" @click="submitForm">Submit</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="Delete Department"
      :visible.sync="deleteDepartmentModalVisible"
      size="tiny"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false">
      <span>
        Are you sure you want to delete department?
          <ul class="showlist">
           <li v-for="(item, index) in displayingdata" :key="index">
           <!-- This {{ item.code }} 
           {{ item.name }}
           {{ item.users.length > 0 ? 'has assigned users.' : 'does not have any assigned users.' }} -->
           {{ item.code }} 
           {{ item.name }}
           </li>
          </ul>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button class="exit-modal-btn" type="primary" @click="cancelDepartmentDelete" :disabled="deletingVendor">
          No
        </el-button>
        <el-button type="primary" @click="deleteDepartment" :loading="deletingVendor">
          Yes
        </el-button>
      </span>
    </el-dialog>
  </el-col>
</template>

<script>
  import { payload } from '@/components/RouteComponents/Departments/actionPayload'
  import HeaderInfoText from '@/components/HeaderInfoText'
  import store from '@/store/store'
  import NewEntityForm from '@/components/NewEntityForm.vue'
  import { createNewModel } from '@/components/RouteComponents/commonFunctions'
  import { DataLoader } from '@/utils/helpers/DataLoader/DataLoader'
  import { systemViewMixins } from '@/Mixins/SystemViewMixins'
  import AutocompleteLocalSearch from '@/utils/helpers/Search/AutocompleteLocalSearch'
  import { payload as accountActionPayload } from '@/components/RouteComponents/Accounts/actionPayload'

  export default {
    components: {
      HeaderInfoText,
      NewEntityForm
    },
    mixins: [ systemViewMixins ],
    data () {
      return {
        tableHeight: 1000,
        selection: [],
        dialogFormVisible: false,
        changingPage: false,
        editMode: { active: false, modelId: null },
        disabled: false,
        displayingdata: [],
        batchUpdateOptions: [
          { id: 0, text: 'Delete selected' }
        ],
        batchUpdateSelection: null,
        deleteDepartmentModalVisible: false,
        deletingVendor: false,
        notificationShown: false
      }
    },
    methods: {
      /**
       * Resets editMode data, resets form to initial state, and displays the
       * modal to create a new model
       */
      createNewModel () {
        createNewModel(this)
      },
      trackFormChange (targetfields) {
        if (targetfields.all_accounts === true) {
          this.disabled = !this.disabled
          targetfields.from_account.label = ''
          targetfields.from_account.value = ''
          targetfields.to_account.label = ''
          targetfields.to_account.value = ''
          this.fields[2].disabled = true
          this.fields[3].disabled = true
          this.fields[2].required = false
          this.fields[3].required = false
        } else {
          this.disabled = false
        }
      },
      closeFormModal () {
        this.disabled = false
        this.dialogFormVisible = false
      },
      confirmDeletingDepartment () {
        this.batchUpdateSelection = null
        this.deleteDepartmentModalVisible = true
      },
      cancelDepartmentDelete () {
        this.deleteDepartmentModalVisible = false
      },
      deleteDepartment () {
        const payload = {
          ids: this.displayingdata
          .filter(item => item.users.length === 0) // Filter items with no users
          .map(item => item.id)
        }
        const departmentsWithUsers = this.displayingdata.filter(item => item.users.length > 0).map(item => `• ${item.name} (${item.code})`)
        if (payload.ids.length > 0) {
          this.$store.dispatch('deleteDepartment', payload)
          .then(response => {
            this.deleteDepartmentModalVisible = false
            this.deletingVendor = false
            this.$notify({ title: 'Success', message: 'Departments deleted successfully.', type: 'success' })
            this.displayingdata = []
            this.selection = []
            this.$refs[`${this.endpoint}Table`].clearSelection()
            if (departmentsWithUsers.length > 0) {
              setTimeout(() => {
                this.$notify({
                  title: 'Warning',
                  message: `Sorry, you cannot delete this departments:\n${departmentsWithUsers.join('\n')}\n\n because other data may depend on this. Please contact support for assistance.`,
                  type: 'warning',
                  offset: 0
                })
              }, 2000)
            }
          })
        } else {
          this.deleteDepartmentModalVisible = false
          this.$refs[`${this.endpoint}Table`].clearSelection()
          this.selection = []
          this.$notify({
            title: 'Warning',
            message: `Sorry, you cannot delete this departments:\n${departmentsWithUsers.join('\n')}\n\n because other data may depend on this. Please contact support for assistance.`,
            type: 'warning'
          })
        }
      },
      handleTableSelectionChange (id) {
        this.displayingdata = id
        this.selection = id
      }
    },
    computed: {
      postableAccounts () {
        return this.$store.getters.getAllAccounts.filter(account => account.postable)
      },
      data () {
        return this.sortData(this.$store.getters.getAllDepartments)
      },
      pageData () {
        return this.meetsFilterCriteria(this.data).slice((this.currentPage - 1) * 20, this.currentPage * 20)
      },
      getAllDepartments () {
        return this.$store.getters.getAllDepartments
      },
      meta () {
        return { count: this.meetsFilterCriteria(this.data).length, shown: this.pageData.length }
      },
      fields () {
        return [
          {
            label: 'Code',
            name: 'code',
            type: 'string',
            fieldType: 'input',
            required: true,
            triggerOnFocus: true,
            msg: 'Code field is required.'
          },
          {
            label: 'Department Name',
            name: 'name',
            type: 'string',
            fieldType: 'input',
            required: true,
            msg: 'Department Name field is required.'
          },
          {
            label: 'From Account',
            name: 'from_account',
            custom_name: 'from_account',
            type: 'field',
            fieldType: 'autocomplete',
            options: () => new AutocompleteLocalSearch(this.postableAccounts, accountActionPayload, 'from_account').createOptions(),
            remote: false,
            triggerOnFocus: false,
            disabled: this.disabled,
            actionPayload: accountActionPayload,
            msg: 'From account is required when All Accounts is not selected.',
            required: true
          },
          {
            label: 'To account',
            name: 'to_account',
            custom_name: 'to_account',
            type: 'field',
            fieldType: 'autocomplete',
            options: () => new AutocompleteLocalSearch(this.postableAccounts, accountActionPayload, 'to_account').createOptions(),
            remote: false,
            triggerOnFocus: false,
            disabled: this.disabled,
            actionPayload: accountActionPayload,
            msg: 'To account is required when All Accounts is not selected.',
            required: true
          },
          {
            label: 'Description',
            name: 'description',
            type: 'string',
            fieldType: 'input'
          },
          {
            label: 'All accounts',
            name: 'all_accounts',
            type: 'boolean',
            fieldType: 'checkbox',
            choices: [
              ...this.getAllDepartments.map(department => {
                return { display_name: department.all_accounts, value: department.all_accounts }
              })
            ]
          }
        ]
      }
    },
    watch: {
      pageData () {
        if (this.restoreTableSelection && typeof this.restoreTableSelection === 'function') {
          this.restoreTableSelection()
        }
      }
    },
    /**
       * Pre-route enter logic.
       * @param to
       * @param from
       * @param next
       */
    async beforeRouteEnter (to, from, next) {
      let initPromises = []
      const fieldsAlreadyExist = !typeof store.getters.getResourceFieldsByEndpoint(payload.endpoint) === 'undefined'
      if (!fieldsAlreadyExist) {
        initPromises.push(store.dispatch('fetchDepartmentsWithQuery', payload))
      }
      try {
        await Promise.all(initPromises)
        if (from.path !== '/') {
          let dataLoader = new DataLoader(store, [ payload ], true, 200)
          await dataLoader.loadData()
        }
      } catch (e) {
        console.log('error', e)
      } finally {
        next()
      }
    },
    created () {
      this.endpoint = payload.endpoint
      this.moduleName = payload.moduleName
      this.payload = payload
      this.generateForm()
    },
    mounted () {
      this.$nextTick = () => {
        const tableHeight = () => {
          const parentHeight = document.getElementById('core-col').offsetHeight
          const headerHeight = document.getElementById('departments-header').offsetHeight
          return parentHeight - headerHeight
        }
        this.tableHeight = tableHeight()
      }
    }
  }
</script>

<style scoped>

.h-padded {
  padding: 0 12px
}
.right-aligned-col {
  text-align: right
}
.el-table .modified-row {
  background: #c9e5f5
}
.selected-element {
  display: flex;
  float: right;
}
.showlist {
  margin-top: 8px;
  padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/RouteComponents/Departments/Departments.vue